import '/components/cookie-notice/cookie-notice';
import '/components/cookie-notice/cookie-notice.scss';
